module.exports = require("webpack");